import type { SVGProps } from "react";

/**
 * Season / sprinkle — hand or shaker scattering salt / herbs.
 */
export function SeasonIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Shaker body */}
      <rect
        x={16}
        y={4}
        width={16}
        height={24}
        rx={3}
        fill="currentColor"
        opacity={0.15}
      />
      <rect
        x={16}
        y={4}
        width={16}
        height={24}
        rx={3}
        stroke="currentColor"
        strokeWidth={1.2}
        opacity={0.5}
        fill="none"
      />
      {/* Lid */}
      <rect
        x={18}
        y={2}
        width={12}
        height={4}
        rx={1.5}
        fill="currentColor"
        opacity={0.6}
      />
      {/* Holes */}
      <circle cx={22} cy={4} r={0.8} fill="currentColor" opacity={0.7} />
      <circle cx={26} cy={4} r={0.8} fill="currentColor" opacity={0.7} />
      {/* Falling granules */}
      <circle cx={20} cy={30} r={1.2} fill="currentColor" opacity={0.5} />
      <circle cx={26} cy={32} r={1} fill="currentColor" opacity={0.4} />
      <circle cx={22} cy={34} r={1.2} fill="currentColor" opacity={0.5} />
      <circle cx={28} cy={36} r={0.8} fill="currentColor" opacity={0.3} />
      <circle cx={24} cy={38} r={1} fill="currentColor" opacity={0.4} />
      <circle cx={19} cy={36} r={0.8} fill="currentColor" opacity={0.35} />
      <circle cx={30} cy={33} r={0.7} fill="currentColor" opacity={0.3} />
    </svg>
  );
}
